var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
export function canVoteElection(election, votes, completedAcclaimed) {
    var _a;
    if (completedAcclaimed === void 0) { completedAcclaimed = false; }
    if (completedAcclaimed)
        return false;
    var limit = (_a = election.num_allowed_revotes) !== null && _a !== void 0 ? _a : 1;
    return (limit === 0 ||
        votes.filter(function (vote) { return vote.status !== CastVoteStatus.DISCARDED; }).length < limit);
}
export var CastVoteStatus;
(function (CastVoteStatus) {
    CastVoteStatus["IN_PROGRESS"] = "in-progress";
    CastVoteStatus["VALID"] = "valid";
    CastVoteStatus["DISCARDED"] = "discarded";
})(CastVoteStatus || (CastVoteStatus = {}));
/** Validate the database string before storing it as a voting status. */
export function parseCastVoteStatus(status) {
    switch (status) {
        case CastVoteStatus.IN_PROGRESS:
        case CastVoteStatus.VALID:
        case CastVoteStatus.DISCARDED:
            return status;
        default:
            throw new Error("Unknown cast vote status");
    }
}
var initialState = {};
export var castVotesSlice = createSlice({
    name: "castVotes",
    initialState: initialState,
    reducers: {
        addCastVotes: function (state, action) {
            var _loop_1 = function (castVote) {
                if (!castVote.election_id) {
                    return "continue";
                }
                if (castVote.status === CastVoteStatus.DISCARDED) {
                    state[castVote.election_id] = (state[castVote.election_id] || []).filter(function (cv) { return castVote.id !== cv.id; });
                    return "continue";
                }
                state[castVote.election_id] = __spreadArray(__spreadArray([], (state[castVote.election_id] || []).filter(function (cv) { return castVote.id !== cv.id; }), true), [
                    castVote,
                ], false);
            };
            for (var _i = 0, _a = action.payload; _i < _a.length; _i++) {
                var castVote = _a[_i];
                _loop_1(castVote);
            }
            return state;
        },
    },
});
export var addCastVotes = castVotesSlice.actions.addCastVotes;
export var selectCastVotesByElectionId = function (electionId) { return function (state) {
    return state.castVotes[electionId] || [];
}; };
export var canVoteSomeElection = function () {
    return function (state) {
        return Object.values(state.elections).some(function (election) {
            var _a;
            return !!election &&
                canVoteElection(election, state.castVotes[election.id] || [], (_a = state.extra.completedAcclaimedElections) === null || _a === void 0 ? void 0 : _a[election.id]);
        });
    };
};
export default castVotesSlice.reducer;
